import './assets/css/main.css'
import Vue from 'vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { addUserOperateRecordFn } from '@/utils/index'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
import _ from 'lodash'
Vue.prototype.$_ = _
// 将方法挂载到 Vue 原型上
Vue.prototype.$addUserOperateRecord = addUserOperateRecordFn
import App from './App.vue'
import router from './router'
import store from './store/'

import splitPane from 'vue-splitpane'

import './style/index.scss'

import './permission'

// import { createApp } from "vue";

const getUserPermissions = () => {
  const user = JSON.parse(localStorage.getItem('menuList')) || []
  return user || []
}

// const app = createApp(App);
// 获取用户权限
const userPermissions = getUserPermissions()
console.log('userPermissions: ', userPermissions)

// 动态生成侧边栏菜单
console.log('router: ', router)

const sidebarMenu = router
  .getRoutes()

  .filter((route) => route.meta && route.meta.showInSidebar)
  .filter((route) =>
    route.meta.requiredPermissions.some((permission) =>
      userPermissions.includes(permission)
    )
  )
  .map((route) => ({
    title: route.meta.title,
    path: route.path,
    icon: route.meta.icon || ''
  }))
console.log('sidebarMenu: ', sidebarMenu)

// 存储到 Vuex 或本地存储
// setSidebarMenu(sidebarMenu); // Vuex action
// localStorage.setItem("sidebarMenu", JSON.stringify(sidebarMenu)); // 或者存储到本地存储

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.component('SplitPane', splitPane)
Vue.config.productionTip = false
Vue.config.errorHandler = function(err, vm, info) {
  // 处理错误
  console.error('捕获的全局错误:', err)
  console.error('错误信息:', info)
}

// 处理未捕获的 Promise 拒绝
window.addEventListener('unhandledrejection', function(event) {
  // 参数 event 包含了 Promise 和原因
  const { reason } = event

  // 处理错误
  console.error('未处理的 Promise 拒绝:', reason)

  // 防止默认的拒绝处理（如在控制台打印未处理的拒绝错误）
  event.preventDefault()
})

new Vue({
  render: (h) => h(App),
  router,
  store
}).$mount('#app')
